import { AppliedDiscountDefinitionDto } from '@/features/public/booking/types/AppliedDiscountDto.ts';
import { DiscountType } from '@/features/dashboard/discounts/types/DiscountType.ts';

/**
 * Czytelny opis mechaniki rabatu na podstawie jego definicji (bez nawiasów).
 * Zwracany tylko dla rabatu procentowego (np. "12% EUR" / "12% EUR, maks. 500 EUR") -
 * waluta jest istotna, bo rabat dotyczy rezerwacji w konkretnej walucie.
 * Dla rabatu kwotowego pełną informację niesie już sama kwota zniżki, więc `null`.
 */
export const getDiscountMechanicLabel = (
  definition: AppliedDiscountDefinitionDto,
): string | null => {
  if (definition.type !== DiscountType.PERCENTAGE) {
    return null;
  }
  const base = `${definition.value}% ${definition.currency}`;
  return definition.maxDiscountAmount != null
    ? `${base}, maks. ${definition.maxDiscountAmount} ${definition.currency}`
    : base;
};
